import { render, staticRenderFns } from "./EventTabInvitations.vue?vue&type=template&id=6f62407b&scoped=true&"
import script from "./EventTabInvitations.vue?vue&type=script&lang=js&"
export * from "./EventTabInvitations.vue?vue&type=script&lang=js&"
import style0 from "./EventTabInvitations.vue?vue&type=style&index=0&id=6f62407b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f62407b",
  null
  
)

export default component.exports